var SimPROLegend = L.Control.extend ({
  options: {
    position: 'bottomright',
  },
  initialize: function(id, title, colour, legendID, options) {
    this.id = id;
    this.title = title;
    this.colour = colour;
    this.legendID = legendID;
    L.setOptions(this, options);
  },

  onAdd: function(map) {
    let legendContainer = L.DomUtil.create('div', 'googleMapLegend');
    let container = L.DomUtil.create('div', 'googleMapLegendItem', legendContainer);

    let left = L.DomUtil.create('div', 'left', container);
    let right = L.DomUtil.create('div', 'right', container);
    let box = L.DomUtil.create('div', 'right googleMapLegendBox', container);

    let checkBox = "<input type=\"checkbox\" onclick='toggleMapElement(\""+ this.legendID +"\", \"marker\")' checked=\"checked\" />";
    let goToPoint = "<span class=\"googleMapLocationIcon icon-search\" onclick='goToPoint(\"" + this.legendID + "\", \"marker\")' title='Show position'></span>";

    left.innerHTML = this.title;
    right.innerHTML = goToPoint + ' ' + checkBox;
    box.innerHTML = this.id;
    box.style["background-color"] = "#" + this.colour;
    return legendContainer;
  }
});
